import React from "react";
import {Button, Checkbox, Empty, notification, Popconfirm, Result, Spin, Tag, Tooltip} from "antd";
import './Dashboard.less';
import PageHeader from "../views/PageHeader";
import Div from "../views/Div";
import Sections from "../views/Sections";
import BlockHeader from "../views/BlockHeader";
import Card from "../views/Card";
import {
    CaretRightOutlined,
    CheckOutlined,
    ClockCircleOutlined,
    CoffeeOutlined,
    FieldTimeOutlined,
    FormOutlined,
    HomeOutlined,
    LaptopOutlined,
    ToolOutlined,
    UngroupOutlined,
} from "@ant-design/icons";
import SData from "../../helpers/SData";
import SystemFunctions from "../../helpers/SystemFunctions";
import Server from "../../helpers/Server";
import TimeLogic from "../../helpers/TimeLogic";
import CurrentTask from "../elements/CurrentTask";
import DashboardStats from "../elements/DashboardStats";

export default class Dashboard extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: false,
        };
    }

    renderActionsButtons = () => {
        if (SData.base.purpose == null) {
            return null;
        }
        switch (SData.base.purpose.status) {
            case 0:
                return <div className='actionsButtons'>
                    <Button className='editTasks blue' type='primary' icon={<FormOutlined/>}
                            onClick={() => this.props.openMenu('tasks')}>Редактировать задачи</Button>
                </div>;
            case 1:
                return <div className='actionsButtons'>
                    <Button className='waitPurpose' type='primary' icon={<ClockCircleOutlined/>} disabled={true}>Цель на
                        утверждении</Button>
                </div>;
            case 2:
                if (SData.base.status === 0) {
                    return <div className='actionsButtons'>
                        <Popconfirm okType='success'
                                    okButtonProps={{className: 'btn-object'}}
                                    placement="bottomLeft"
                                    title="Вы действительно хотите начать рабочий день?"
                                    onConfirm={this.onStartDay}
                                    okText="Да" cancelText="Отмена">
                            <Button className='startWork blue' type='primary' icon={<CaretRightOutlined/>}>Начать
                                рабочий день</Button>
                        </Popconfirm>
                        <Button className='skipDay red' type='primary' icon={<FieldTimeOutlined/>}>Пропустить
                            день</Button>
                    </div>;
                } else {
                    return <div className='actionsButtons'>
                        <Popconfirm okType='success'
                                    okButtonProps={{className: 'btn-object'}}
                                    placement="bottomLeft"
                                    title="Вы действительно хотите завершить рабочий день?"
                                    onConfirm={this.onFinishDay}
                                    okText="Да" cancelText="Отмена">
                            <Button className='endWork red' type='primary' icon={<HomeOutlined/>}>Завершить рабочий
                                день</Button>
                        </Popconfirm>
                        {SData.base.status === 2 ?
                            <Button className='endBreak green' type='primary' icon={<LaptopOutlined/>} onClick={this.onEndBreak}>Завершить
                                перерыв</Button> :
                            <Button className='startBreak orange' type='primary' icon={<CoffeeOutlined/>} onClick={this.onStartBreak}>Начать
                                перерыв</Button>
                        }
                    </div>;
                }
            case 3:
                return <div className='actionsButtons'>
                    <Button className='waitPurpose' type='primary' icon={<CheckOutlined/>} disabled={true}>Цель
                        завершена</Button>
                </div>;
            default:
                return null;
        }
    }

    render() {
        return (
            <div className='Dashboard'>
                <PageHeader title='Рабочая панель' statusUser={SData.base.status}/>
                {SData.base.purpose != null ? <Div>
                    <Sections>
                        <div className='leftPart'>
                            <div className='activeTask'>
                                <BlockHeader text='Активная задача' status='processing'/>
                                <CurrentTask onCompleteTask={this.onCompleteTask}/>
                                {this.renderActionsButtons()}
                            </div>
                        </div>
                        <div className='rightPart'>
                            <BlockHeader text='Статистика' status='warning'/>
                            <DashboardStats/>
                        </div>
                    </Sections>
                    {this.state.loading ? <div className='loadingScreen'>
                        <Spin className='loadingSpin' size="large" tip="Ожидайте..."/>
                    </div> : null}
                </Div> : <Div className='noPurpose'>
                    <Result
                        icon={<UngroupOutlined fill='#1890ff'/>}
                        title="Нет цели"
                    />
                </Div>}
            </div>
        );
    }

    onCompleteTask = () => {
        this.setState({loading: true});
        Server.query(Server.QUERY_PURPOSE, {a: 'completeTask', id: SData.currentTask.id}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerTasks(r.tasks);
                SData.setFromServerCurrentTasks(r.currentTask);
                this.setState({loading: false});
                notification.success({
                    message: 'Задача успешно завершена',
                    placement: 'bottomRight',
                });
            } else {
                notification.error({
                    message: r.error,
                    placement: 'bottomRight',
                });
                this.setState({loading: false});
            }
        }, () => {
            this.setState({loading: false});
            notification.error({
                message: Server.ERROR_TEXT_CONNECTION,
                placement: 'bottomRight',
            });
        });
    }

    onStartDay = () => {
        this.setState({loading: true});
        Server.query(Server.QUERY_PURPOSE, {a: 'startDay'}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerCurrentTasks(r.currentTask);
                this.setState({loading: false});
                notification.success({
                    message: 'Вы начали рабочий день',
                    placement: 'bottomRight',
                });
            } else {
                notification.error({
                    message: r.error,
                    placement: 'bottomRight',
                });
                this.setState({loading: false});
            }
        }, () => {
            this.setState({loading: false});
            notification.error({
                message: Server.ERROR_TEXT_CONNECTION,
                placement: 'bottomRight',
            });
        });
    }

    onFinishDay = () => {
        this.setState({loading: true});
        Server.query(Server.QUERY_PURPOSE, {a: 'finishDay'}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerCurrentTasks(r.currentTask);
                this.setState({loading: false});
                notification.success({
                    message: 'Рабочий день завершен',
                    placement: 'bottomRight',
                });
            } else {
                notification.error({
                    message: r.error,
                    placement: 'bottomRight',
                });
                this.setState({loading: false});
            }
        }, () => {
            this.setState({loading: false});
            notification.error({
                message: Server.ERROR_TEXT_CONNECTION,
                placement: 'bottomRight',
            });
        });
    }

    onStartBreak = () => {
        this.setState({loading: true});
        Server.query(Server.QUERY_PURPOSE, {a: 'startBreak'}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerCurrentTasks(r.currentTask);
                this.setState({loading: false});
                notification.success({
                    message: 'Вы начали перерыв',
                    placement: 'bottomRight',
                });
            } else {
                notification.error({
                    message: r.error,
                    placement: 'bottomRight',
                });
                this.setState({loading: false});
            }
        }, () => {
            this.setState({loading: false});
            notification.error({
                message: Server.ERROR_TEXT_CONNECTION,
                placement: 'bottomRight',
            });
        });
    }

    onEndBreak = () => {
        this.setState({loading: true});
        Server.query(Server.QUERY_PURPOSE, {a: 'finishBreak'}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerCurrentTasks(r.currentTask);
                this.setState({loading: false});
                notification.success({
                    message: 'Перерыв завершен',
                    placement: 'bottomRight',
                });
            } else {
                notification.error({
                    message: r.error,
                    placement: 'bottomRight',
                });
                this.setState({loading: false});
            }
        }, () => {
            this.setState({loading: false});
            notification.error({
                message: Server.ERROR_TEXT_CONNECTION,
                placement: 'bottomRight',
            });
        });
    }
}